import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@material-ui/core";
import { BriefingFormModel } from "pages/BriefingForm/interfaces";
import { Controller } from "react-hook-form";
import { MAX_BUNDLE_LENGTH } from "validation/components/BriefingForm/briefingFormRules";
import { useTranslation } from "react-i18next";

const options = [
    {
        id: "Half_Page_300x600",
        label: "briefingForm.label.halfPage",
    },
    {
        id: "Leaderboard_728x90",
        label: "briefingForm.label.leaderBoard",
    },
    {
        id: "MREC_300x250",
        label: "briefingForm.label.mrec",
    },
    {
        id: "Mobile_Banner_320x50",
        label: "briefingForm.label.mobileBanner",
    },
    {
        id: "Skyscraper_160x600",
        label: "briefingForm.label.skyscraper",
    },
    {
        id: "Billboard_970x250",
        label: "briefingForm.label.billboard",
    },
    {
        id: "Side_Skins_260x1050",
        label: "briefingForm.label.sideSkins",
    },
];

interface BundleProps extends FieldsHookForm<BriefingFormModel> {
    selectedIds: string[];
    // eslint-disable-next-line
    onAdSizeSelect(onChange: (...event: any[]) => void, clickedId: string): void;
    isMaxSelected(selectedIds: string[], id: string, maxLength: number): boolean;
}

export const Bundle: React.FC<BundleProps> = ({ control, selectedIds, onAdSizeSelect, isMaxSelected }) => {
    const { t } = useTranslation();
    return (
        <Box>
            <Typography variant="subtitle2">{t("briefingForm.label.upto5Sizes")}</Typography>
            <Box display="flex" justifyContent="center" flexWrap="wrap">
                {options.map(({ id, label }) => (
                    <Controller
                        key={id}
                        control={control}
                        type="checkbox"
                        name="adSize.sizes"
                        render={({ onChange }) => {
                            return (
                                <FormControlLabel
                                    style={{ flex: "1 1 200px" }}
                                    onChange={() => onAdSizeSelect(onChange, id)}
                                    label={t(label)}
                                    control={<Checkbox name={id} color="primary" />}
                                    checked={selectedIds.includes(id)}
                                    disabled={isMaxSelected(selectedIds, id, MAX_BUNDLE_LENGTH)}
                                />
                            );
                        }}
                    />
                ))}
            </Box>
        </Box>
    );
};
